import NativeSerial from "../NativeSerial";

class Device extends NativeSerial {
	instructions = [
		"please_step_on_weight_scale"
	]
	instruction_audio = "05_1.mp3"
	values = ["wt","ht"]
	count = 0

    constructor(port) {
		super();
		this.connect(port);
	}

	connect(port) {
		if(!this.isNative)return;
		if(this.oldSerial) {
			this.port = new this.serialport(port,{ // eslint-disable-line no-undef
				baudRate: 9600,
				dataBits: 8,
				parity: 'none',
				stopBits: 1
			});
		} else {
			this.port = new this.serialport({ // eslint-disable-line no-undef
				baudRate: 9600,
				dataBits: 8,
				parity: 'none',
				stopBits: 1,
				path:port
			  });
		}
	}
	
    read(cb,errorcb,statuscb) {
		if(!this.isNative)return;

        this.port.on("open", (err) => {
			if(err){
				console.log(err)
				statuscb({reading:false, error:true})
			} else {
				console.log("Port opened");
				this.parse(cb,errorcb,statuscb)
				statuscb({reading:true, error:false})
			}
		});
	
		this.port.on('error', (err) => { 
			console.log('Error: ', err);
			statuscb({reading:false, error:true})
		});
	
		this.port.on('close', (err) => { 
			console.log("Device Closed. Error: ", err);  
			statuscb({reading:false, error:false})  
		});

		this.port.on('disconnect', function (err) { 
			console.log("Disconnected. Error: ", err);   
			statuscb({reading:false, error:true}) 
		});
	}
	
	parse(cb,errorcb,statuscb) {
		if(!this.isNative)return;

		let parser = this.port.pipe(new this.delimiter({ delimiter: new Buffer.from('\n') })); // eslint-disable-line no-undef

		// var parser = this.port.pipe(Readline({delimiter: '\r\n'}));

		parser.on('data',  (data) => {
			let buf = Buffer.from(data, 'ascii')
			let raw = buf.toString('ascii')
			let w = ''
			let startw = raw.indexOf('WEIGHT')
			if(startw > 0) {
				w = raw.substr(startw + 6, 10)
				w = w.trim()
			}
			let h = ''
			let starth = raw.indexOf('HEIGHT')
			if(starth > 0) {
				h = raw.substr(starth + 6, 10)
				h = h.trim()
			}
			this.count++
			if(w) {
				cb({
					wt: w,
					ht: h
				})
			}
			if(w || this.count > 3) {
				statuscb({reading:false, error:false})
				this.close();
			}
		})

		// // var parser = this.port.pipe(new this.delimiter({ delimiter: new Buffer.from('EOL') }));  // eslint-disable-line no-undef
		// parser.on('data',  (data) => {

		// 	let buf = Buffer.from(data, 'ascii')
		// 	console.log(buf)
		// 	console.log(buf.toString('hex'))
		// 	console.log(buf.toString('ascii'))
		// 	// console.log(data)
		// 	// console.log(data.toString('ascii'))
		// 	// let raw = data.toString('ascii').split(',')
		// 	// let indexWt = raw.findIndex(element => element == 'Wk') + 1
		// 	// console.log(raw[indexWt])
		// 	// cb({
		// 	// 	wt: raw[indexWt]
		// 	// })
		// 	statuscb({reading:false, error:false})
			// this.close();

        parser.on('error',  (err) => {
            console.error("bpParser Error", err);
			statuscb({reading:false, error:true})
			errorcb(err);
			this.close();
        });
	}
}
export default Device;